import type { ReportDesignCategoryEnum } from "@q-food/q-food";
import { useUserStore } from "./User";

export const useActionCenterStore = defineStore("ActionCenter", () => {
	const open = ref(false);

	function toggle() {
		open.value = !open.value;
	}

	function openDrawer() {
		open.value = true;
	}

	function close() {
		open.value = false;
	}

	// Which printer a category's labels go to: always the user's saved default preference.
	function printerFor(category?: ReportDesignCategoryEnum | null): string | undefined {
		return useUserStore().getPrinterId(category ?? null);
	}

	return { open, toggle, openDrawer, close, printerFor };
});
